/**
 * Customer 360 — at-a-glance KPI strip. Eight chips, mobile-friendly grid.
 */
import type { Customer360Response } from '@/lib/api';
import { formatPriceMinor } from '@/lib/format';

interface Props {
  data: Customer360Response;
  currency: string;
}

export function Customer360Stats({ data, currency }: Props) {
  const s = data.stats;
  const items: Array<{ label: string; value: string }> = [
    { label: 'Total bookings', value: String(s.totalBookings) },
    { label: 'Cancellation rate', value: `${s.cancellationRatePercent}%` },
    { label: 'No-show rate', value: `${s.noShowRatePercent}%` },
    {
      label: 'Avg booking value',
      value: formatPriceMinor(s.avgBookingValueMinor, currency),
    },
    { label: 'Loyalty balance', value: `${data.loyalty.balance} pts` },
    { label: 'Referrals made', value: String(s.referralsMade) },
    {
      label: 'Active credits',
      value: formatPriceMinor(s.activeCreditsMinor, currency),
    },
    { label: 'Active packs', value: String(s.activePacks) },
  ];
  return (
    <section
      data-testid="customer360-stats"
      className="grid grid-cols-2 gap-2 sm:grid-cols-4 lg:grid-cols-8"
    >
      {items.map((it) => (
        <div
          key={it.label}
          className="min-w-0 rounded-xl border border-border bg-surface px-3 py-2.5"
        >
          <p className="text-[10px] font-medium uppercase leading-tight tracking-wide text-muted-foreground">
            {it.label}
          </p>
          <p className="num mt-0.5 truncate text-base font-semibold tracking-tight">{it.value}</p>
        </div>
      ))}
    </section>
  );
}
